// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2pfK4","filesListContainer":"PosDisputesFiles_filesListContainer__24_l7","filesButton":"PosDisputesFiles_filesButton__STQUb"};